import {
  ButtonHTMLAttributes,
  forwardRef,
  ReactElement,
  ReactNode,
} from 'react';
import cn from 'classnames';

import styles from './PillButton.module.scss';

export type PillButtonSize = 'larger' | 'smaller';

export interface PillButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  label: ReactNode;
  active?: boolean;
  size?: PillButtonSize;
  buttonType?: 'button' | 'submit' | 'reset';
}

const PillButton = forwardRef<HTMLButtonElement, PillButtonProps>(
  (
    {
      label,
      active = false,
      size = 'larger',
      className,
      disabled,
      buttonType = 'button',
      ...restProps
    }: PillButtonProps,
    ref
  ): ReactElement => (
    <button
      ref={ref}
      type={buttonType}
      className={cn(
        styles.pillButton,
        styles[size],
        {
          [styles.active]: active,
        },
        className
      )}
      disabled={disabled}
      {...restProps}
    >
      <span className={styles.label}>{label}</span>
    </button>
  )
);

PillButton.displayName = 'PillButton';

export default PillButton;
